module.exports = __webpack_public_path__ + "img/deny-red.a8efe53d.svg";